import types from './types';

const initialState = {
  uploadingPhotos: false,
  fetchingChildGallery: false,
  byId: {}
};

export const childGalleryReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_CHILD_GALLERY_REQUEST: {
      return {
        ...state,
        fetchingChildGallery: true
      };
    }
    case types.GET_CHILD_GALLERY_SUCCESS: {
      return {
        ...state,
        fetchingChildGallery: false,
        byId: {
          ...state.byId,
          [action.childId]: action.photos
        }
      };
    }
    case types.GET_CHILD_GALLERY_FAILURE: {
      return {
        ...state,
        fetchingChildGallery: false
      };
    }
    case types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_REQUEST: {
      return {
        ...state,
        uploadingPhotos: true
      };
    }
    case types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_SUCCESS:
    case types.UPLOAD_PHOTOS_TO_CHILD_GALLERY_FAILURE: {
      return {
        ...state,
        uploadingPhotos: false
      };
    }
    case types.REMOVE_PHOTO_FROM_CHILD_GALLERY_SUCCESS: {
      const childGalleryCopy = [...state.byId[action.childId]];
      const filteredPhotos = childGalleryCopy.filter(photo => photo.group_image_id !== action.groupImageId);

      return {
        ...state,
        byId: {
          ...state.byId,
          [action.childId]: filteredPhotos
        }
      };
    }
    default:
      return state;
  }
};
